export default __webpack_public_path__ + "static/media/sparkles_img.ff7c84ef.svg";